export enum ItemCardContentDisplayTypeEnum {
  QUANTITY = "quantity",
  MATERIAL_NAMES = "material-names",
}
